import VerticalDotProgress from './VerticalDotProgress'

export default VerticalDotProgress
